import clsx from "clsx";
import { imgAvatar } from "@/shared/assets/img";
import InventoryCloseButton from "@/domains/inventory/components/InventoryCloseButton";

type Props = {
  name: string;
  id: number;
  onClose: () => void;
};

export default function InventoryTradeSelfSuggestionHeader({ name, id, onClose }: Props) {
  return (
    <div
      className={clsx(
        "rounded-b-[1rem] px-7.5 h-[4.875rem] w-full",
        "flex items-center gap-1.5 bg-gradient-to-r from-[#D73434]/30 via-transparent to-dark-800/60",
      )}
    >
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center border border-accent-solid rounded-[0.625rem] w-[2.75rem] h-[2.75rem] shrink-0">
          <img src={imgAvatar} alt="" className="w-[2.5rem] h-[2.5rem] rounded-[0.5rem]" />
        </div>
        <div className="flex flex-col">
          <div className="text-18 font-bold">{name}</div>
          <div className="text-14 text-accent-solid font-medium">#{id}</div>
        </div>
      </div>

      <InventoryCloseButton onClick={onClose} />
    </div>
  );
}
